export default {
  rid: 264,
  last_tax_return_on_options: [
    2017,
    2016
  ],
  flow_variant: 'five_phase_no_transcripts',
  user: {
    hellosign_api_key: '31053d749f6b8fd49d9b24eebf1379b0',
    __typename: 'User'
  },
  affiliates: [],
  businesses: [
    {
      rid: 364,
      name: "FICO 717 Owner's Business",
      borrowerType: 'oc',
      financial: {
        fiscal_year_end_on: '12/31/2017',
        last_tax_return_on: '12/31/2017',
        __typename: 'Financial'
      },
      taxReturns: [
        {
          formName: '1065',
          year: '2017',
          __typename: 'TaxReturn'
        },
        {
          formName: '1065',
          year: '2017',
          __typename: 'TaxReturn'
        },
        {
          formName: '1065',
          year: '2017',
          __typename: 'TaxReturn'
        },
        {
          formName: '1065',
          year: '2017',
          __typename: 'TaxReturn'
        }
      ],
      taxReturnUrls: [],
      documents: [
        {
          rid: 143,
          category: 'business_bank_search',
          phase: 'main',
          title: 'OFAC',
          status: 'pending_review',
          comment: null,
          filenames: [],
          adminOnly: true,
          description: null,
          instructions: '',
          uploaded: false,
          skippable: false,
          editable: false,
          header_image_url: null,
          esignReminderSentAt: null,
          helloSignTemplateId: '',
          helloSignRoles: [],
          esignSigners: [],
          hasUploadNotifications: false,
          custom: false,
          deletable: false,
          esignable: false,
          documentKey: null,
          displayCommentable: true,
          type: 'Document::Ofac',
          skipped: false,
          confirmed: false,
          live: true,
          creditDoc: false,
          bankEditable: false,
          fileUrls: [],
          files: [],
          signatureRequests: [],
          __typename: 'Document'
        },
        {
          rid: 144,
          category: 'business_bank_search',
          phase: 'main',
          title: 'Lien Check',
          status: 'pending_review',
          comment: null,
          filenames: [],
          adminOnly: true,
          description: null,
          instructions: '',
          uploaded: false,
          skippable: false,
          editable: false,
          header_image_url: null,
          esignReminderSentAt: null,
          helloSignTemplateId: '',
          helloSignRoles: [],
          esignSigners: [],
          hasUploadNotifications: false,
          custom: false,
          deletable: false,
          esignable: false,
          documentKey: null,
          displayCommentable: true,
          type: 'Document::LienCheck',
          skipped: false,
          confirmed: false,
          live: true,
          creditDoc: false,
          bankEditable: false,
          fileUrls: [],
          files: [],
          signatureRequests: [],
          __typename: 'Document'
        },
        {
          rid: 145,
          category: 'business_bank_search',
          phase: 'main',
          title: 'Insurance - Flood Search',
          status: 'pending_review',
          comment: null,
          filenames: [],
          adminOnly: true,
          description: null,
          instructions: '',
          uploaded: false,
          skippable: true,
          editable: false,
          header_image_url: null,
          esignReminderSentAt: null,
          helloSignTemplateId: '',
          helloSignRoles: [],
          esignSigners: [],
          hasUploadNotifications: false,
          custom: false,
          deletable: false,
          esignable: false,
          documentKey: null,
          displayCommentable: true,
          type: 'Document::InsuranceFloodSearch',
          skipped: false,
          confirmed: false,
          live: true,
          creditDoc: false,
          bankEditable: false,
          fileUrls: [],
          files: [],
          signatureRequests: [],
          __typename: 'Document'
        },
        {
          rid: 146,
          category: 'business_insurance',
          phase: 'main',
          title: 'Evidence of General Liability Insurance',
          status: 'pending_review',
          comment: null,
          filenames: [],
          adminOnly: true,
          description: null,
          instructions: 'Please give these instructions to your insurance agent. Note: your assigned bank is very particular about the insurance requirements so please let your agent know to pay close attention to the details!',
          uploaded: false,
          skippable: false,
          editable: true,
          header_image_url: null,
          esignReminderSentAt: null,
          helloSignTemplateId: '',
          helloSignRoles: [],
          esignSigners: [],
          hasUploadNotifications: false,
          custom: false,
          deletable: false,
          esignable: false,
          documentKey: null,
          displayCommentable: true,
          type: 'Document::InsuranceGeneralLiability',
          skipped: false,
          confirmed: false,
          live: true,
          creditDoc: false,
          bankEditable: false,
          fileUrls: [],
          files: [],
          signatureRequests: [],
          __typename: 'Document'
        },
        {
          rid: 147,
          category: 'business_insurance',
          phase: 'main',
          title: 'Evidence of Business Property Insurance',
          status: 'pending_review',
          comment: null,
          filenames: [],
          adminOnly: true,
          description: null,
          instructions: 'Please give these instructions to your insurance agent. Note: your assigned bank is very particular about the insurance requirements so please let your agent know to pay close attention to the details!',
          uploaded: false,
          skippable: false,
          editable: true,
          header_image_url: null,
          esignReminderSentAt: null,
          helloSignTemplateId: '',
          helloSignRoles: [],
          esignSigners: [],
          hasUploadNotifications: false,
          custom: false,
          deletable: false,
          esignable: false,
          documentKey: null,
          displayCommentable: true,
          type: 'Document::InsurancePersonalProperty',
          skipped: false,
          confirmed: false,
          live: true,
          creditDoc: false,
          bankEditable: false,
          fileUrls: [],
          files: [],
          signatureRequests: [],
          __typename: 'Document'
        },
        {
          rid: 148,
          category: 'business_insurance',
          phase: 'main',
          title: "Worker's Compensation Insurance",
          status: 'pending_review',
          comment: null,
          filenames: [],
          adminOnly: true,
          description: null,
          instructions: 'Please give these instructions to your insurance agent. Note: your assigned bank is very particular about the insurance requirements so please let your agent know to pay close attention to the details!',
          uploaded: false,
          skippable: true,
          editable: true,
          header_image_url: null,
          esignReminderSentAt: null,
          helloSignTemplateId: '',
          helloSignRoles: [],
          esignSigners: [],
          hasUploadNotifications: false,
          custom: false,
          deletable: false,
          esignable: false,
          documentKey: null,
          displayCommentable: true,
          type: 'Document::InsuranceWorkmansComp',
          skipped: false,
          confirmed: false,
          live: true,
          creditDoc: false,
          bankEditable: false,
          fileUrls: [],
          files: [],
          signatureRequests: [],
          __typename: 'Document'
        },
        {
          rid: 149,
          category: 'business_insurance',
          phase: 'main',
          title: 'Flood Insurance',
          status: 'pending_review',
          comment: null,
          filenames: [],
          adminOnly: true,
          description: null,
          instructions: 'Complete the form and submit to your insurance agent. Upload the certificate of accord naming our lending partner as a loss payee.',
          uploaded: false,
          skippable: true,
          editable: false,
          header_image_url: null,
          esignReminderSentAt: null,
          helloSignTemplateId: '',
          helloSignRoles: [],
          esignSigners: [],
          hasUploadNotifications: false,
          custom: false,
          deletable: false,
          esignable: false,
          documentKey: null,
          displayCommentable: true,
          type: 'Document::InsuranceFlood',
          skipped: false,
          confirmed: false,
          live: true,
          creditDoc: false,
          bankEditable: false,
          fileUrls: [],
          files: [],
          signatureRequests: [],
          __typename: 'Document'
        },
        {
          rid: 150,
          category: 'business_entity',
          phase: 'main',
          title: 'Certificate of Good Standing',
          status: 'pending_review',
          comment: null,
          filenames: [],
          adminOnly: null,
          description: null,
          instructions: "<a target='_blank' href='{:AL=>\"http://sos.alabama.gov/government-records/business-entity-records\", :AK=>\"http://commerce.alaska.gov/CBP/Main/CBPLSearch.aspx?mode=Name\", :AR=>\"http://www.sos.arkansas.gov/corps/search_all.php\", :AZ=>\"http://www.azsos.gov/scripts/TNT_Search_engine.dll\", :CA=>\"https://businesssearch.sos.ca.gov/\", :CO=>\"http://www.sos.state.co.us/biz/BusinessEntityCriteriaExt.do\", :CT=>\"http://www.concord-sots.ct.gov/CONCORD/online?sn=PublicInquiry&eid=9740\", :DE=>\"https://icis.corp.delaware.gov/Ecorp/EntitySearch/NameSearch.aspx\", :FL=>\"http://www.sunbiz.org/search.html\", :GA=>\"https://ecorp.sos.ga.gov/BusinessSearch\", :HI=>\"http://hbe.ehawaii.gov/documents/search.html;jsessionid=284FCBF9ADA4F558FFEA168396A55C74.luka\", :ID=>\"http://www.accessidaho.org/public/sos/corp/search.html?ScriptForm.startstep=crit\", :IL=>\"http://www.ilsos.gov/corporatellc/\", :IN=>\"https://bsd.sos.in.gov/publicbusinesssearch\", :IA=>\"http://sos.iowa.gov/search/business/(S(olaxxhqqhltmeb3vtlgrkorg))/search.aspx\", :KS=>\"https://www.kansas.gov/bess/flow/main;jsessionid=B29E0993734A66E58ABC559E259B17AE.aptcs03-inst0?execution=e1s3\", :KY=>\"https://app.sos.ky.gov/ftsearch/\", :LA=>\"https://coraweb.sos.la.gov/CommercialSearch/CommercialSearch.aspx\", :ME=>\"https://icrs.informe.org/nei-sos-icrs/ICRS\", :MD=>\"http://sdat.dat.maryland.gov/ucc-charter/Pages/CharterSearch/default.aspx\", :MA=>\"http://corp.sec.state.ma.us/corpweb/CorpSearch/CorpSearch.aspx\", :MI=>\"http://www.dleg.state.mi.us/bcs_corp/sr_corp.asp\", :MN=>\"https://mblsportal.sos.state.mn.us/Business/Search\", :MS=>\"https://corp.sos.ms.gov/corp/portal/c/page/corpBusinessIdSearch/portal.aspx?#clear=1\", :MO=>\"https://bsd.sos.mo.gov/BusinessEntity/BESearch.aspx?SearchType=0\", :MT=>\"https://www.mtsosfilings.gov/mtsos-master/service/create.html?service=registerItemSearch\", :NE=>\"https://www.nebraska.gov/sos/corp/corpsearch.cgi?nav=search\", :NV=>\"http://nvsos.gov/sosentitysearch/\", :NH=>\"https://www.sos.nh.gov/corporate/soskb/csearch.asp\", :NJ=>\"https://www.njportal.com/DOR/businessrecords/EntityDocs/BusinessStatCopies.aspx\", :NM=>\"https://portal.sos.state.nm.us/corps/corplookup/Lookdn.aspx\", :NY=>\"http://www.dos.ny.gov/corps/bus_entity_search.html\", :NC=>\"http://www.secretary.state.nc.us/search/index/corp\", :ND=>\"https://apps.nd.gov/sc/busnsrch/busnSearch.htm\", :OH=>\"http://www5.sos.state.oh.us/ords/f?p=100:1:0::NO\", :OK=>\"https://www.sos.ok.gov/business/corp/records.aspx\", :OR=>\"http://egov.sos.state.or.us/br/pkg_web_name_srch_inq.login\", :PA=>\"https://www.corporations.pa.gov/search/corpsearch\", :RI=>\"http://ucc.state.ri.us/CorpSearch/CorpSearchInput.asp\", :SC=>\"http://www.sos.sc.gov/Search%20Business%20Filings\", :SD=>\"https://sos.sd.gov/business/search.aspx\", :TN=>\"http://tnbear.tn.gov/Ecommerce/FilingSearch.aspx\", :TX=>\"https://mycpa.cpa.state.tx.us/coa/\", :UT=>\"https://secure.utah.gov/bes/\", :VT=>\"https://www.vtsosonline.com/online/BusinessInquire\", :VA=>\"https://sccefile.scc.virginia.gov/Find/Business\", :WA=>\"http://www.sos.wa.gov/corps/corps_search.aspx\", :WV=>\"https://apps.wv.gov/SOS/BusinessEntitySearch/\", :WI=>\"https://www.wdfi.org/apps/CorpSearch/Search.aspx?\", :WY=>\"https://wyobiz.wy.gov/business/filingsearch.aspx\", :DC=>\"https://corp.dcra.dc.gov/Account.aspx/LogOn?ReturnUrl=%2fHome.aspx\"}'>Click here to visit your state's website.</a> You will be able to search for this document there. Take a screen shot of the page that shows your business has active status and/or is in good standing with the state. Then upload this to the SmartBiz application.",
          uploaded: false,
          skippable: false,
          editable: true,
          header_image_url: null,
          esignReminderSentAt: null,
          helloSignTemplateId: '',
          helloSignRoles: [],
          esignSigners: [],
          hasUploadNotifications: false,
          custom: false,
          deletable: false,
          esignable: false,
          documentKey: null,
          displayCommentable: true,
          type: 'Document::GoodsCertificate',
          skipped: false,
          confirmed: false,
          live: true,
          creditDoc: false,
          bankEditable: false,
          fileUrls: [],
          files: [],
          signatureRequests: [],
          __typename: 'Document'
        },
        {
          rid: 151,
          category: 'business_entity',
          phase: 'main',
          title: 'LLC Articles of Organization',
          status: 'pending_review',
          comment: null,
          filenames: [],
          adminOnly: null,
          description: null,
          instructions: 'Provide a copy of the original Articles of Organization with the state’s stamp or seal indicating the Articles were filed with the state. Ensure you include all amendments to the Articles. If you do not have a copy of your Articles of Organization, you can order them on your state’s Secretary of State website.',
          uploaded: false,
          skippable: false,
          editable: true,
          header_image_url: null,
          esignReminderSentAt: null,
          helloSignTemplateId: '',
          helloSignRoles: [],
          esignSigners: [],
          hasUploadNotifications: false,
          custom: false,
          deletable: false,
          esignable: false,
          documentKey: null,
          displayCommentable: true,
          type: 'Document::LlcOrganization',
          skipped: false,
          confirmed: false,
          live: true,
          creditDoc: false,
          bankEditable: false,
          fileUrls: [],
          files: [],
          signatureRequests: [],
          __typename: 'Document'
        },
        {
          rid: 152,
          category: 'business_entity',
          phase: 'main',
          title: 'Operating Agreement',
          status: 'pending_review',
          comment: null,
          filenames: [],
          adminOnly: false,
          description: null,
          instructions: "If you do not have an Operating Agreement, you can create a free one in under 5 minutes using a legal services website, such as <a href='http://www.lawdepot.com/contracts/llc-operating-agreement/#.VyQQ4cdAA28' target='_blank'>LawDepot</a>.",
          uploaded: false,
          skippable: false,
          editable: true,
          header_image_url: null,
          esignReminderSentAt: null,
          helloSignTemplateId: '',
          helloSignRoles: [],
          esignSigners: [],
          hasUploadNotifications: false,
          custom: false,
          deletable: false,
          esignable: false,
          documentKey: null,
          displayCommentable: true,
          type: 'Document::OperatingAgreement',
          skipped: false,
          confirmed: false,
          live: true,
          creditDoc: false,
          bankEditable: false,
          fileUrls: [],
          files: [],
          signatureRequests: [],
          __typename: 'Document'
        },
        {
          rid: 153,
          category: 'business_entity',
          phase: 'main',
          title: 'Asset List',
          status: 'pending_review',
          comment: null,
          filenames: [],
          adminOnly: null,
          description: null,
          instructions: 'Provide details about the assets your business owns, as described in the form. Don’t forget to include serial numbers for assets that have a market value greater than $5,000. Use additional pages if needed.',
          uploaded: false,
          skippable: false,
          editable: true,
          header_image_url: null,
          esignReminderSentAt: null,
          helloSignTemplateId: '',
          helloSignRoles: [],
          esignSigners: [],
          hasUploadNotifications: false,
          custom: false,
          deletable: false,
          esignable: false,
          documentKey: null,
          displayCommentable: true,
          type: 'Document::BusinessAssets',
          skipped: false,
          confirmed: false,
          live: true,
          creditDoc: false,
          bankEditable: false,
          fileUrls: [],
          files: [],
          signatureRequests: [],
          __typename: 'Document'
        },
        {
          rid: 154,
          category: 'business_entity',
          phase: 'closing',
          title: "Certificate of Limited Liability Company's Members",
          status: 'pending_review',
          comment: null,
          filenames: [],
          adminOnly: null,
          description: null,
          instructions: "Provide details of your LLC's membership and ownership structure. This certificate must be signed by the Managing Member. If needed, reference your Operating Agreement for details about your company’s members and officers.",
          uploaded: false,
          skippable: false,
          editable: true,
          header_image_url: null,
          esignReminderSentAt: null,
          helloSignTemplateId: 'cdf332d24f3eefd3b6e5bbefbce91ea57aca4050',
          helloSignRoles: [
            {
              rid: '00e5c5b3-3ddc-4d4a-a78c-d4e7f2ae4b1a',
              value: 'signer',
              label: 'Authorized Signer',
              __typename: 'SelectorOption'
            }
          ],
          esignSigners: [
            {
              rid: '2180b106-7775-4760-889b-e019a6f6bf9b',
              role: 'signer',
              email: null,
              name: 'Emond Champagne',
              __typename: 'GuarantorOption'
            }
          ],
          hasUploadNotifications: false,
          custom: false,
          deletable: false,
          esignable: true,
          documentKey: null,
          displayCommentable: true,
          type: 'Document::CertificateLlcMembers',
          skipped: false,
          confirmed: false,
          live: true,
          creditDoc: false,
          bankEditable: false,
          fileUrls: [],
          files: [],
          signatureRequests: [],
          __typename: 'Document'
        },
        {
          rid: 155,
          category: 'business_financial_and_underwriting',
          phase: 'main',
          title: 'Business TaxReturns',
          status: 'pending_review',
          comment: null,
          filenames: [],
          adminOnly: true,
          description: null,
          instructions: 'Business TaxReturns',
          uploaded: false,
          skippable: true,
          editable: true,
          header_image_url: null,
          esignReminderSentAt: null,
          helloSignTemplateId: '',
          helloSignRoles: [],
          esignSigners: [],
          hasUploadNotifications: false,
          custom: false,
          deletable: false,
          esignable: false,
          documentKey: null,
          displayCommentable: true,
          type: 'Document::TaxReturns',
          skipped: false,
          confirmed: false,
          live: true,
          creditDoc: false,
          bankEditable: false,
          fileUrls: [],
          files: [],
          signatureRequests: [],
          __typename: 'Document'
        },
        {
          rid: 156,
          category: 'business_entity',
          phase: 'closing',
          title: 'Member Resolution to Borrow',
          status: 'pending_review',
          comment: null,
          filenames: [],
          adminOnly: null,
          description: null,
          instructions: 'Have the resolution signed by all members. It requires a signature from each member and the managing member must sign at the bottom.',
          uploaded: false,
          skippable: false,
          editable: true,
          header_image_url: null,
          esignReminderSentAt: null,
          helloSignTemplateId: 'ca8a0aa9f510886a7a51b8aa5ce8db4a6f9f4978',
          helloSignRoles: [
            {
              rid: 'd355cc5b-caf2-4b17-a38e-7332d03ffe7c',
              value: 'signer_1',
              label: 'Owner 1',
              __typename: 'SelectorOption'
            },
            {
              rid: '860a1100-50ad-4630-88fc-e1a876298804',
              value: 'signer_2',
              label: 'Owner 2',
              __typename: 'SelectorOption'
            },
            {
              rid: '3eab41d1-cd06-4dbf-a8fe-a17d0ff18868',
              value: 'signer_3',
              label: 'Owner 3',
              __typename: 'SelectorOption'
            },
            {
              rid: '6805d854-be98-4d30-bd81-1c3c84e4317a',
              value: 'signer_4',
              label: 'Owner 4',
              __typename: 'SelectorOption'
            }
          ],
          esignSigners: [
            {
              rid: 'fc75d120-aca7-4eef-9cdb-0db867e19ee9',
              role: 'signer_1',
              email: null,
              name: 'Curtis Chacon',
              __typename: 'GuarantorOption'
            },
            {
              rid: '04c34b77-bc8d-453d-bc37-0ddf7901f57d',
              role: 'signer_2',
              email: null,
              name: 'Emond Champagne',
              __typename: 'GuarantorOption'
            }
          ],
          hasUploadNotifications: false,
          custom: false,
          deletable: false,
          esignable: true,
          documentKey: null,
          displayCommentable: true,
          type: 'Document::MemberResolutionBorrow',
          skipped: false,
          confirmed: false,
          live: true,
          creditDoc: false,
          bankEditable: false,
          fileUrls: [],
          files: [],
          signatureRequests: [],
          __typename: 'Document'
        },
        {
          rid: 157,
          category: 'business_financial_and_underwriting',
          phase: 'main',
          title: '4506T Request',
          status: 'approve_and_commit',
          comment: null,
          filenames: [
            'Screen_Shot_2018-03-13_at_2.33.00_PM.png'
          ],
          adminOnly: true,
          description: null,
          instructions: 'Please scroll down and electronically sign the form. This will complete the tax transcript order so SmartBiz can review your business’s financial qualifications for an SBA loan.',
          uploaded: true,
          skippable: false,
          editable: false,
          header_image_url: null,
          esignReminderSentAt: null,
          helloSignTemplateId: '0439746dfd79bb58d4adb85b19bd54f024425ea8',
          helloSignRoles: [
            {
              rid: 'dc35452f-f842-48f6-b3b8-132ff1a058a0',
              value: 'signer',
              label: 'Signer',
              __typename: 'SelectorOption'
            }
          ],
          esignSigners: [],
          hasUploadNotifications: false,
          custom: false,
          deletable: true,
          esignable: false,
          documentKey: 'fcbc1a40a9d44c5c3cd0ac11aade9acad52d2d35',
          displayCommentable: true,
          type: 'Document::T4506t',
          skipped: false,
          confirmed: true,
          live: false,
          creditDoc: false,
          bankEditable: false,
          fileUrls: [
            {
              filename: 'Screen_Shot_2018-03-13_at_2.33.00_PM.png',
              link: '/admin/loans/264/download_file?document=157&filename=Screen_Shot_2018-03-13_at_2.33.00_PM.png',
              rid: '12900a31-699a-425d-b12e-d627e29fa914',
              __typename: 'FileLink'
            }
          ],
          files: [
            {
              rid: 'ec7bf1ba-096f-4354-8490-b1ffb6481a9f',
              isNew: false,
              name: 'Screen_Shot_2018-03-13_at_2.33.00_PM.png',
              __typename: 'File'
            }
          ],
          signatureRequests: [],
          __typename: 'Document'
        },
        {
          rid: 164,
          category: 'business_financial_and_underwriting',
          phase: 'main',
          title: '2017 Tax Return',
          status: 'pending_review',
          comment: null,
          filenames: [],
          adminOnly: null,
          description: null,
          instructions: 'Include all pages, including the schedules and statements.',
          uploaded: false,
          skippable: true,
          editable: true,
          header_image_url: null,
          esignReminderSentAt: null,
          helloSignTemplateId: '',
          helloSignRoles: [],
          esignSigners: [],
          hasUploadNotifications: false,
          custom: false,
          deletable: false,
          esignable: false,
          documentKey: null,
          displayCommentable: true,
          type: 'Document::BusinessTaxReturnLastYear',
          skipped: false,
          confirmed: false,
          live: true,
          creditDoc: false,
          bankEditable: false,
          fileUrls: [],
          files: [],
          signatureRequests: [],
          __typename: 'Document'
        },
        {
          rid: 165,
          category: 'business_financial_and_underwriting',
          phase: 'main',
          title: '2016 Tax Return',
          status: 'pending_review',
          comment: null,
          filenames: [],
          adminOnly: null,
          description: null,
          instructions: 'Include all pages, including the schedules and statements.',
          uploaded: false,
          skippable: true,
          editable: true,
          header_image_url: null,
          esignReminderSentAt: null,
          helloSignTemplateId: '',
          helloSignRoles: [],
          esignSigners: [],
          hasUploadNotifications: false,
          custom: false,
          deletable: false,
          esignable: false,
          documentKey: null,
          displayCommentable: true,
          type: 'Document::BusinessTaxReturnPriorYear',
          skipped: false,
          confirmed: false,
          live: true,
          creditDoc: false,
          bankEditable: false,
          fileUrls: [],
          files: [],
          signatureRequests: [],
          __typename: 'Document'
        },
        {
          rid: 166,
          category: 'business_financial_and_underwriting',
          phase: 'main',
          title: '2015 Tax Return',
          status: 'pending_review',
          comment: null,
          filenames: [],
          adminOnly: null,
          description: null,
          instructions: 'Include all pages, including the schedules and statements.',
          uploaded: false,
          skippable: true,
          editable: true,
          header_image_url: null,
          esignReminderSentAt: null,
          helloSignTemplateId: '',
          helloSignRoles: [],
          esignSigners: [],
          hasUploadNotifications: false,
          custom: false,
          deletable: false,
          esignable: false,
          documentKey: null,
          displayCommentable: true,
          type: 'Document::BusinessTaxReturnTwoYearsPrior',
          skipped: false,
          confirmed: false,
          live: true,
          creditDoc: false,
          bankEditable: false,
          fileUrls: [],
          files: [],
          signatureRequests: [],
          __typename: 'Document'
        },
        {
          rid: 168,
          category: 'business_financial_and_underwriting',
          phase: 'main',
          title: 'Balance Sheet',
          status: 'pending_review',
          comment: null,
          filenames: [],
          adminOnly: null,
          description: null,
          instructions: '',
          uploaded: false,
          skippable: false,
          editable: true,
          header_image_url: null,
          esignReminderSentAt: null,
          helloSignTemplateId: '',
          helloSignRoles: [],
          esignSigners: [],
          hasUploadNotifications: false,
          custom: false,
          deletable: false,
          esignable: false,
          documentKey: null,
          displayCommentable: true,
          type: 'Document::BalanceSheet',
          skipped: false,
          confirmed: false,
          live: true,
          creditDoc: false,
          bankEditable: false,
          fileUrls: [],
          files: [],
          signatureRequests: [],
          __typename: 'Document'
        },
        {
          rid: 177,
          category: 'business_bank_search',
          phase: 'main',
          title: 'Business Credit Report',
          status: 'pending_review',
          comment: null,
          filenames: [],
          adminOnly: true,
          description: null,
          instructions: '',
          uploaded: false,
          skippable: false,
          editable: false,
          header_image_url: null,
          esignReminderSentAt: null,
          helloSignTemplateId: '',
          helloSignRoles: [],
          esignSigners: [],
          hasUploadNotifications: false,
          custom: false,
          deletable: false,
          esignable: false,
          documentKey: null,
          displayCommentable: true,
          type: 'Document::BusinessCreditData',
          skipped: false,
          confirmed: false,
          live: true,
          creditDoc: false,
          bankEditable: false,
          fileUrls: [],
          files: [],
          signatureRequests: [],
          __typename: 'Document'
        },
        {
          rid: 178,
          category: 'business_location',
          phase: 'main',
          title: 'Google Streetview of Business Location',
          status: 'pending_review',
          comment: null,
          filenames: [],
          adminOnly: true,
          description: null,
          instructions: '',
          uploaded: false,
          skippable: false,
          editable: false,
          header_image_url: null,
          esignReminderSentAt: null,
          helloSignTemplateId: '',
          helloSignRoles: [],
          esignSigners: [],
          hasUploadNotifications: false,
          custom: false,
          deletable: false,
          esignable: false,
          documentKey: null,
          displayCommentable: true,
          type: 'Document::BusinessStreetView',
          skipped: false,
          confirmed: false,
          live: true,
          creditDoc: false,
          bankEditable: false,
          fileUrls: [],
          files: [],
          signatureRequests: [],
          __typename: 'Document'
        },
        {
          rid: 179,
          category: 'business_entity',
          phase: 'main',
          title: 'License',
          status: 'pending_review',
          comment: null,
          filenames: [],
          adminOnly: null,
          description: null,
          instructions: 'Provide a copy of the business registration document, or certificate, you received from your city or county.',
          uploaded: false,
          skippable: true,
          editable: true,
          header_image_url: null,
          esignReminderSentAt: null,
          helloSignTemplateId: '',
          helloSignRoles: [],
          esignSigners: [],
          hasUploadNotifications: false,
          custom: false,
          deletable: false,
          esignable: false,
          documentKey: null,
          displayCommentable: true,
          type: 'Document::BusinessLicense',
          skipped: false,
          confirmed: false,
          live: true,
          creditDoc: false,
          bankEditable: false,
          fileUrls: [],
          files: [],
          signatureRequests: [],
          __typename: 'Document'
        },
        {
          rid: 180,
          category: 'business_funding',
          phase: 'closing',
          title: 'Photo of Voided Business Check',
          status: 'pending_review',
          comment: null,
          filenames: [],
          adminOnly: null,
          description: null,
          instructions: 'Upload a photo or color copy of a voided check from your business bank checking account.',
          uploaded: false,
          skippable: false,
          editable: true,
          header_image_url: null,
          esignReminderSentAt: null,
          helloSignTemplateId: '',
          helloSignRoles: [],
          esignSigners: [],
          hasUploadNotifications: false,
          custom: false,
          deletable: false,
          esignable: false,
          documentKey: null,
          displayCommentable: true,
          type: 'Document::VoidedBusinessBankAccountCheck',
          skipped: false,
          confirmed: false,
          live: true,
          creditDoc: false,
          bankEditable: false,
          fileUrls: [],
          files: [],
          signatureRequests: [],
          __typename: 'Document'
        },
        {
          rid: 182,
          category: 'business_financial_and_underwriting',
          phase: 'main',
          title: '2018 Profit & Loss Statement',
          status: 'pending_review',
          comment: null,
          filenames: [],
          adminOnly: null,
          description: null,
          instructions: '',
          uploaded: false,
          skippable: false,
          editable: true,
          header_image_url: null,
          esignReminderSentAt: null,
          helloSignTemplateId: '',
          helloSignRoles: [],
          esignSigners: [],
          hasUploadNotifications: false,
          custom: false,
          deletable: false,
          esignable: false,
          documentKey: null,
          displayCommentable: true,
          type: 'Document::LastIncomeStatement',
          skipped: false,
          confirmed: false,
          live: true,
          creditDoc: false,
          bankEditable: false,
          fileUrls: [],
          files: [],
          signatureRequests: [],
          __typename: 'Document'
        }
      ],
      archivedDocuments: [],
      guarantors: [
        {
          rid: 464,
          name: 'Curtis Chacon',
          email: null,
          taxReturns: [],
          taxReturnUrls: [],
          business: {
            rid: 364,
            __typename: 'Business'
          },
          documents: [
            {
              rid: 158,
              category: 'Curtis Chacon',
              phase: 'closing',
              title: "Photo of Driver's License",
              status: 'pending_review',
              comment: null,
              filenames: [],
              adminOnly: null,
              description: null,
              instructions: 'Provide a photo or color copy of the front and back of your identification. Taking a photo with your smartphone works well.',
              uploaded: false,
              skippable: false,
              editable: true,
              header_image_url: null,
              esignReminderSentAt: null,
              helloSignTemplateId: '',
              helloSignRoles: [],
              esignSigners: [],
              hasUploadNotifications: false,
              custom: false,
              deletable: false,
              esignable: false,
              documentKey: null,
              displayCommentable: true,
              type: 'Document::DriverLicensePhoto',
              skipped: false,
              confirmed: false,
              live: true,
              creditDoc: false,
              bankEditable: false,
              fileUrls: [],
              files: [],
              signatureRequests: [],
              __typename: 'Document'
            },
            {
              rid: 159,
              category: 'Curtis Chacon',
              phase: 'main',
              title: 'Guarantor TaxReturns',
              status: 'pending_review',
              comment: null,
              filenames: [],
              adminOnly: true,
              description: null,
              instructions: 'Guarantor TaxReturns',
              uploaded: false,
              skippable: true,
              editable: true,
              header_image_url: null,
              esignReminderSentAt: null,
              helloSignTemplateId: '',
              helloSignRoles: [],
              esignSigners: [],
              hasUploadNotifications: false,
              custom: false,
              deletable: false,
              esignable: false,
              documentKey: null,
              displayCommentable: true,
              type: 'Document::TaxReturns',
              skipped: false,
              confirmed: false,
              live: true,
              creditDoc: false,
              bankEditable: false,
              fileUrls: [],
              files: [],
              signatureRequests: [],
              __typename: 'Document'
            },
            {
              rid: 160,
              category: 'Curtis Chacon',
              phase: 'main',
              title: '4506T Request',
              status: 'approve_and_commit',
              comment: null,
              filenames: [],
              adminOnly: true,
              description: null,
              instructions: 'Please scroll down and electronically sign the form. This will complete the tax transcript order so SmartBiz can review your business’s financial qualifications for an SBA loan.',
              uploaded: false,
              skippable: false,
              editable: false,
              header_image_url: null,
              esignReminderSentAt: null,
              helloSignTemplateId: '0439746dfd79bb58d4adb85b19bd54f024425ea8',
              helloSignRoles: [
                {
                  rid: '168d434e-ef85-473a-ae3c-ef01e5f92708',
                  value: 'signer',
                  label: 'Signer',
                  __typename: 'SelectorOption'
                }
              ],
              esignSigners: [],
              hasUploadNotifications: false,
              custom: false,
              deletable: true,
              esignable: false,
              documentKey: null,
              displayCommentable: true,
              type: 'Document::T4506t',
              skipped: false,
              confirmed: true,
              live: false,
              creditDoc: false,
              bankEditable: false,
              fileUrls: [],
              files: [],
              signatureRequests: [],
              __typename: 'Document'
            },
            {
              rid: 169,
              category: 'Curtis Chacon',
              phase: 'main',
              title: '2017 Personal Tax Return',
              status: 'pending_review',
              comment: null,
              filenames: [],
              adminOnly: null,
              description: null,
              instructions: 'Include all pages, including the schedules and statements.',
              uploaded: false,
              skippable: true,
              editable: true,
              header_image_url: null,
              esignReminderSentAt: null,
              helloSignTemplateId: '',
              helloSignRoles: [],
              esignSigners: [],
              hasUploadNotifications: false,
              custom: false,
              deletable: false,
              esignable: false,
              documentKey: null,
              displayCommentable: true,
              type: 'Document::PersonalTaxReturnLastYear',
              skipped: false,
              confirmed: false,
              live: true,
              creditDoc: false,
              bankEditable: false,
              fileUrls: [],
              files: [],
              signatureRequests: [],
              __typename: 'Document'
            },
            {
              rid: 170,
              category: 'Curtis Chacon',
              phase: 'main',
              title: '2016 Personal Tax Return',
              status: 'pending_review',
              comment: null,
              filenames: [],
              adminOnly: null,
              description: null,
              instructions: 'Include all pages, including the schedules and statements.',
              uploaded: false,
              skippable: true,
              editable: true,
              header_image_url: null,
              esignReminderSentAt: null,
              helloSignTemplateId: '',
              helloSignRoles: [],
              esignSigners: [],
              hasUploadNotifications: false,
              custom: false,
              deletable: false,
              esignable: false,
              documentKey: null,
              displayCommentable: true,
              type: 'Document::PersonalTaxReturnPriorYear',
              skipped: false,
              confirmed: false,
              live: true,
              creditDoc: false,
              bankEditable: false,
              fileUrls: [],
              files: [],
              signatureRequests: [],
              __typename: 'Document'
            },
            {
              rid: 171,
              category: 'Curtis Chacon',
              phase: 'main',
              title: '2015 Personal Tax Return',
              status: 'pending_review',
              comment: null,
              filenames: [],
              adminOnly: null,
              description: null,
              instructions: 'Include all pages, including the schedules and statements.',
              uploaded: false,
              skippable: true,
              editable: true,
              header_image_url: null,
              esignReminderSentAt: null,
              helloSignTemplateId: '',
              helloSignRoles: [],
              esignSigners: [],
              hasUploadNotifications: false,
              custom: false,
              deletable: false,
              esignable: false,
              documentKey: null,
              displayCommentable: true,
              type: 'Document::PersonalTaxReturnTwoYearsPrior',
              skipped: false,
              confirmed: false,
              live: true,
              creditDoc: false,
              bankEditable: false,
              fileUrls: [],
              files: [],
              signatureRequests: [],
              __typename: 'Document'
            },
            {
              rid: 175,
              category: 'Curtis Chacon',
              phase: 'main',
              title: 'Experian Credit Data Soft Pull',
              status: 'approve_and_commit',
              comment: null,
              filenames: [
                'cbd_info20180904-31501-1mjrgf2.xml'
              ],
              adminOnly: true,
              description: null,
              instructions: '',
              uploaded: true,
              skippable: false,
              editable: false,
              header_image_url: null,
              esignReminderSentAt: null,
              helloSignTemplateId: '',
              helloSignRoles: [],
              esignSigners: [],
              hasUploadNotifications: false,
              custom: false,
              deletable: false,
              esignable: false,
              documentKey: null,
              displayCommentable: true,
              type: 'Document::ExperianCreditDataSoft',
              skipped: false,
              confirmed: true,
              live: false,
              creditDoc: true,
              bankEditable: false,
              fileUrls: [
                {
                  filename: 'cbd_info20180904-31501-1mjrgf2.xml',
                  link: '/admin/loans/264/credit_report?document=175',
                  rid: '19973d52-6d5f-4da9-9c05-bbce6278574d',
                  __typename: 'FileLink'
                }
              ],
              files: [
                {
                  rid: 'f4d7a223-214d-4ebd-ad09-943fe624d055',
                  isNew: false,
                  name: 'cbd_info20180904-31501-1mjrgf2.xml',
                  __typename: 'File'
                }
              ],
              signatureRequests: [],
              __typename: 'Document'
            }
          ],
          archivedDocuments: [],
          __typename: 'Guarantor'
        },
        {
          rid: 465,
          name: 'Emond Champagne',
          email: null,
          taxReturns: [],
          taxReturnUrls: [],
          business: {
            rid: 364,
            __typename: 'Business'
          },
          documents: [
            {
              rid: 161,
              category: 'Emond Champagne',
              phase: 'closing',
              title: "Photo of Driver's License",
              status: 'pending_review',
              comment: null,
              filenames: [],
              adminOnly: null,
              description: null,
              instructions: 'Provide a photo or color copy of the front and back of your identification. Taking a photo with your smartphone works well.',
              uploaded: false,
              skippable: false,
              editable: true,
              header_image_url: null,
              esignReminderSentAt: null,
              helloSignTemplateId: '',
              helloSignRoles: [],
              esignSigners: [],
              hasUploadNotifications: false,
              custom: false,
              deletable: false,
              esignable: false,
              documentKey: null,
              displayCommentable: true,
              type: 'Document::DriverLicensePhoto',
              skipped: false,
              confirmed: false,
              live: true,
              creditDoc: false,
              bankEditable: false,
              fileUrls: [],
              files: [],
              signatureRequests: [],
              __typename: 'Document'
            },
            {
              rid: 162,
              category: 'Emond Champagne',
              phase: 'main',
              title: 'Guarantor TaxReturns',
              status: 'pending_review',
              comment: null,
              filenames: [],
              adminOnly: true,
              description: null,
              instructions: 'Guarantor TaxReturns',
              uploaded: false,
              skippable: true,
              editable: true,
              header_image_url: null,
              esignReminderSentAt: null,
              helloSignTemplateId: '',
              helloSignRoles: [],
              esignSigners: [],
              hasUploadNotifications: false,
              custom: false,
              deletable: false,
              esignable: false,
              documentKey: null,
              displayCommentable: true,
              type: 'Document::TaxReturns',
              skipped: false,
              confirmed: false,
              live: true,
              creditDoc: false,
              bankEditable: false,
              fileUrls: [],
              files: [],
              signatureRequests: [],
              __typename: 'Document'
            },
            {
              rid: 163,
              category: 'Emond Champagne',
              phase: 'main',
              title: '4506T Request',
              status: 'approve_and_commit',
              comment: null,
              filenames: [],
              adminOnly: true,
              description: null,
              instructions: 'Please scroll down and electronically sign the form. This will complete the tax transcript order so SmartBiz can review your business’s financial qualifications for an SBA loan.',
              uploaded: false,
              skippable: false,
              editable: false,
              header_image_url: null,
              esignReminderSentAt: null,
              helloSignTemplateId: '0439746dfd79bb58d4adb85b19bd54f024425ea8',
              helloSignRoles: [
                {
                  rid: 'c13f57d7-e6ed-4d7f-9738-4f3909d34326',
                  value: 'signer',
                  label: 'Signer',
                  __typename: 'SelectorOption'
                }
              ],
              esignSigners: [],
              hasUploadNotifications: false,
              custom: false,
              deletable: true,
              esignable: false,
              documentKey: null,
              displayCommentable: true,
              type: 'Document::T4506t',
              skipped: false,
              confirmed: true,
              live: false,
              creditDoc: false,
              bankEditable: false,
              fileUrls: [],
              files: [],
              signatureRequests: [],
              __typename: 'Document'
            },
            {
              rid: 172,
              category: 'Emond Champagne',
              phase: 'main',
              title: '2017 Personal Tax Return',
              status: 'pending_review',
              comment: null,
              filenames: [],
              adminOnly: null,
              description: null,
              instructions: 'Include all pages, including the schedules and statements.',
              uploaded: false,
              skippable: true,
              editable: true,
              header_image_url: null,
              esignReminderSentAt: null,
              helloSignTemplateId: '',
              helloSignRoles: [],
              esignSigners: [],
              hasUploadNotifications: false,
              custom: false,
              deletable: false,
              esignable: false,
              documentKey: null,
              displayCommentable: true,
              type: 'Document::PersonalTaxReturnLastYear',
              skipped: false,
              confirmed: false,
              live: true,
              creditDoc: false,
              bankEditable: false,
              fileUrls: [],
              files: [],
              signatureRequests: [],
              __typename: 'Document'
            },
            {
              rid: 173,
              category: 'Emond Champagne',
              phase: 'main',
              title: '2016 Personal Tax Return',
              status: 'pending_review',
              comment: null,
              filenames: [],
              adminOnly: null,
              description: null,
              instructions: 'Include all pages, including the schedules and statements.',
              uploaded: false,
              skippable: true,
              editable: true,
              header_image_url: null,
              esignReminderSentAt: null,
              helloSignTemplateId: '',
              helloSignRoles: [],
              esignSigners: [],
              hasUploadNotifications: false,
              custom: false,
              deletable: false,
              esignable: false,
              documentKey: null,
              displayCommentable: true,
              type: 'Document::PersonalTaxReturnPriorYear',
              skipped: false,
              confirmed: false,
              live: true,
              creditDoc: false,
              bankEditable: false,
              fileUrls: [],
              files: [],
              signatureRequests: [],
              __typename: 'Document'
            },
            {
              rid: 174,
              category: 'Emond Champagne',
              phase: 'main',
              title: '2015 Personal Tax Return',
              status: 'pending_review',
              comment: null,
              filenames: [],
              adminOnly: null,
              description: null,
              instructions: 'Include all pages, including the schedules and statements.',
              uploaded: false,
              skippable: true,
              editable: true,
              header_image_url: null,
              esignReminderSentAt: null,
              helloSignTemplateId: '',
              helloSignRoles: [],
              esignSigners: [],
              hasUploadNotifications: false,
              custom: false,
              deletable: false,
              esignable: false,
              documentKey: null,
              displayCommentable: true,
              type: 'Document::PersonalTaxReturnTwoYearsPrior',
              skipped: false,
              confirmed: false,
              live: true,
              creditDoc: false,
              bankEditable: false,
              fileUrls: [],
              files: [],
              signatureRequests: [],
              __typename: 'Document'
            },
            {
              rid: 176,
              category: 'Emond Champagne',
              phase: 'main',
              title: 'Experian Credit Data Soft Pull',
              status: 'approve_and_commit',
              comment: null,
              filenames: [
                'cbd_info20180904-31501-k57rhh.xml'
              ],
              adminOnly: true,
              description: null,
              instructions: '',
              uploaded: true,
              skippable: false,
              editable: false,
              header_image_url: null,
              esignReminderSentAt: null,
              helloSignTemplateId: '',
              helloSignRoles: [],
              esignSigners: [],
              hasUploadNotifications: false,
              custom: false,
              deletable: false,
              esignable: false,
              documentKey: null,
              displayCommentable: true,
              type: 'Document::ExperianCreditDataSoft',
              skipped: false,
              confirmed: true,
              live: false,
              creditDoc: true,
              bankEditable: false,
              fileUrls: [
                {
                  filename: 'cbd_info20180904-31501-k57rhh.xml',
                  link: '/admin/loans/264/credit_report?document=176',
                  rid: 'f607ca70-cbe3-4e95-9d09-85ca5b4d70ec',
                  __typename: 'FileLink'
                }
              ],
              files: [
                {
                  rid: '33cc8644-3a2c-46aa-b89c-7ceacda0d6e7',
                  isNew: false,
                  name: 'cbd_info20180904-31501-k57rhh.xml',
                  __typename: 'File'
                }
              ],
              signatureRequests: [],
              __typename: 'Document'
            }
          ],
          archivedDocuments: [],
          __typename: 'Guarantor'
        }
      ],
      corporateGuarantors: [],
      senior_staff: [],
      __typename: 'Business'
    }
  ],
  creditMemoAuthWarnings: [],
  __typename: 'Loan'
}
